module.exports = __webpack_public_path__ + "img/icon-github.c639cd27.svg";